import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <div className="animate-spin">
        <Loader2 className="h-8 w-8 text-foreground" />
      </div>
    </div>
  );
};

export default LoadingOverlay;
